module.exports = __webpack_public_path__ + "media/components/page-footer/static/surf-icon-background-f73d8080799e8447bd2a3c53f716b3a1.svg";